import * as React from "react";
import { connect } from "react-redux";
import * as actions from "../../actions/";
import StoreStar from "../store-star";
import SignIn from "../../layout/sign-in";
import axios from "axios";
import CONSTS from "../../consts";
const LiquorIcon = require("!svg-react-loader?name=LiquorIcon!../../../wwwroot/img/liquor-connect-logo.svg");
export class Header extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        if (this.props.SetAuth) {
            let htmlSelector = document.querySelector("html");
            let login = Boolean(JSON.parse(htmlSelector.getAttribute("data-authenticated")));
            this.props.SetAuth(login);
            axios
                .get("/Manage/GetFavoriteStore")
                .then(response => {
                let flist = response.data.favoriteStore;
                if (this.props.GetFavorite && flist) {
                    this.props.GetFavorite(flist);
                }
            });
            this.props.SetAuth(login);
        }
    }
    render() {
        const supplier = this.props.supplier;
        const hero_image = `${CONSTS.STORAGEURL}/${CONSTS.LICENSEECONTAINER}/${supplier.Id}-Logo.jpg`;
        return (React.createElement("div", { className: "header-A-Wrap" },
            React.createElement("div", { className: "header-A" },
                React.createElement("a", { href: "/" },
                    React.createElement(LiquorIcon, { className: "liquor-logo" })),
                React.createElement("img", { className: "store-logo", src: hero_image }),
                React.createElement("span", { className: "additional-logos-inline" },
                    supplier.AHLAMember ? React.createElement("img", { src: `${CONSTS.STORAGEURL}/${CONSTS.LOGOCONTAINER}/AHLA Logo.jpg` }) : null,
                    supplier.ALSAMember ? React.createElement("img", { src: `${CONSTS.STORAGEURL}/${CONSTS.LOGOCONTAINER}/ALSA Logo.jpg` }) : null),
                React.createElement(StoreStar, { id: supplier.Id }),
                React.createElement(SignIn, { modalOpen: this.props.signInModal, toggle: this.props.ToggleLogin, fromHeader: this.props.signInFromHeader })),
            React.createElement("div", { className: "additional-logos" },
                supplier.AHLAMember ? React.createElement("img", { src: `${CONSTS.STORAGEURL} /${CONSTS.LOGOCONTAINER}/AHLA Logo.jpg` }) : null,
                supplier.ALSAMember ? React.createElement("img", { src: `${CONSTS.STORAGEURL}/${CONSTS.LOGOCONTAINER}/ALSA Logo.jpg` }) : null)));
    }
}
export function mapStateToProps({ shoppingList, authenticated, signInModal, signInFromHeader }, OwnProps) {
    return {
        shoppingList,
        authenticated,
        signInModal,
        signInFromHeader,
        supplier: OwnProps.supplier
    };
}
export function mapDispatchToProps(dispatch) {
    return {
        SetAuth: (login) => dispatch(actions.SetAuth(login)),
        GetFavorite: (flist) => dispatch(actions.GetFavorite(flist)),
        ToggleLogin: () => dispatch(actions.ToggleLogin())
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Header);
//# sourceMappingURL=header-shared.js.map